import React, { useState } from 'react';
import { Box } from '@mui/material';
import ActiveFilters from './ActiveFilters';
import Table from './Table';
import Toolbar from './Toolbar';
import styles from './styles';

const DataView = ({
  filterFields = [],
  filterForm,
  onFilter,
  toolbarActions = [],
  onSelectionChange,
  fillHeight = false,
  ...props
}) => {
  const [selection, setSelection] = useState([]);

  const handleSelectionChange = (value) => {
    setSelection(value);

    if (onSelectionChange) {
      onSelectionChange(value);
    }
  };

  return (
    <Box sx={fillHeight ? styles.containerFill : undefined}>
      <Toolbar
        actions={toolbarActions}
        filterFields={filterFields}
        filterForm={filterForm}
        grid={props.grid}
        loading={props.loading}
        onFilter={onFilter}
        selection={selection}
      />
      <ActiveFilters
        fields={filterFields}
        form={filterForm}
        grid={props.grid}
        onChange={onFilter}
      />
      <Table
        {...props}
        fillHeight={fillHeight}
        onSelectionChange={handleSelectionChange}
      />
    </Box>
  );
};

export { default as ActiveFilters } from './ActiveFilters';
export { default as FilterBar } from './FilterBar';
export { default as Table } from './Table';
export { default as RowActions } from './RowActions';
export { default as Toolbar } from './Toolbar';
export { default as useDataViewFilters } from './useDataViewFilters';
export default DataView;
